import React, { useEffect, useContext } from 'react';
import Form from './components/Form'
import Player from './components/Player';
import { Provider } from './PlayerBuilderContext';
import schema from '../schemas/player.json';
import defaultOptions from '../types/defaultOptions';
import Editor from './components/Editor';
import { InitOptions } from '../types/player';
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";


let formStyle = {
    height: '100vh',
    padding: '10px',
    overflow: 'auto',
}
let borderStyle = {
    border: '3px solid #aaa',
}
//TODO get the color from the get parameter



function doDiff(data: any, defaultOpt: any) {        
    let diff: any = {};
    for (var i in data) {
        let value = data[i];
        if (typeof value === 'object') {
            if (value instanceof Array) {
                if (!defaultOpt[i]) {
                    console.log('diff no more present', i, value);
                    if(value.length > 0)
                        diff[i] = value;
                }
                else {
                    if (JSON.stringify(value) != JSON.stringify(defaultOpt[i])) {
                        console.log('diff array', i, value, defaultOpt[i]);
                        diff[i] = value;
                    }
                }
            }
            else {
                if (!defaultOpt[i])
                    defaultOpt[i] = {};
                
                let diffRes = doDiff(value, defaultOpt[i])
                if (Object.keys(diffRes).length > 0) {
                    diff[i] = diffRes;
                }                    
            }

        }
        else {
            if (value != defaultOpt[i]) {
                console.log('diff', i, value, defaultOpt[i]);
                diff[i] = value;
            }
        }
    }

    return diff;
}

function getJs(json: InitOptions, optionsOverride: string) {
    let optionsOverrideObj = {};
    try {
        optionsOverrideObj = JSON.parse(optionsOverride) as InitOptions;
    }
    catch(err) {

    }
    let finalJson = {
        ...json,
        ...optionsOverrideObj
    };
    return `var playerElement = document.getElementById("player-wrapper");
var player = new BlastreamPlayer(playerElement, ${JSON.stringify(finalJson, null, 2)});
`
}

export default function PlayerBuilder() {

    let opt = JSON.parse(JSON.stringify(defaultOptions));        
    opt.source = {
        url: 'https://www.blastream.com/demo/mp4/BigBuckBunny_320x180.mp4'
    }

    let diff = opt;
    let hasDeveloper: any = null;
    if(window.location.search) {
        let urlParams = new URLSearchParams(window.location.search);
        let options = urlParams.get('options');
        if(options) {
            options = options.replaceAll('$', '#')
            console.log('options', options);
            diff = JSON.parse(options);
            opt = { ...defaultOptions, ...diff };
        }
        hasDeveloper = urlParams.get('developer');
    }    

    const [formOptions, setFormOptions] = React.useState(opt);
    const [diffOptions, setDiffOptions] = React.useState(diff);

    useEffect(() => {

        function init() {            
            let diff = doDiff(formOptions, defaultOptions);
            console.log('diff', diff, 'formOptions', formOptions, 'defaultOptions', defaultOptions);
            setDiffOptions(diff);            
        }

        init();

    }, []);

    useEffect(() => {
        
        let diff = doDiff(formOptions, defaultOptions);
        console.log('diff', diff, 'formOptions', formOptions, 'defaultOptions', defaultOptions);
        setDiffOptions(diff);
        if(!hasDeveloper && window.parent)
            window.parent.postMessage({ type: 'BlastreamPlayerOptData', data: diff }, '*');
        let urlDev = hasDeveloper ? `&developer=${hasDeveloper}` : '';
        window.history.pushState({}, '', `?form=1${urlDev}&options=${JSON.stringify(diff).replaceAll('#', '$')}`);
        
        console.log('update origin diff');
       
    }, [formOptions]);

    let jsStorage = `//Write your JS code here`;
    try {
        jsStorage = localStorage.getItem('js') ? localStorage.getItem('js') as string : jsStorage;
    } catch(err) {}

    let cssStorage = `/* Write your CSS code here */`;
    try {
        cssStorage = localStorage.getItem('css') ? localStorage.getItem('css') as string : cssStorage;
    } catch(err) {}

    let optionsOverrideStorage = '//override options here, be careful to put json only and remove this comment'
    try {
        optionsOverrideStorage = localStorage.getItem('optionsOverride') ? localStorage.getItem('optionsOverride') as string : optionsOverrideStorage;
    } catch(err) {}
    
    const [js, setJs ] = React.useState(jsStorage);
    const [css, setCss] = React.useState(cssStorage);
    const [optionsOverride, setOptionsOverride] = React.useState(optionsOverrideStorage);
    const [reload, setReload] = React.useState(false);

    if(window.parent) {
        window.addEventListener('message', function (event) {  
          if (event.data && event.data.type && event.data.type == 'BlastreamPlayerOptDataFromParent' && event.data.data) {     
            console.log('event.data.data from parent', event.data.data);       
            let { diffOptions, css, js, optionsOverride } = event.data.data;            
            setReload(true);
            if(css)
                setCss(css);
            if(js)
                setJs(js);
            if(optionsOverride)
                setOptionsOverride(optionsOverride);
            if(diffOptions) {
                setDiffOptions(diffOptions);
                let opt = { ...defaultOptions, ...diffOptions };
                setFormOptions(opt);
            }
            this.setTimeout(() => {
                setReload(false);
            }, 1000)
          }
        });
    }

    if(reload)
        return null;

    return (
        <Provider schema={schema} defaultOptions={defaultOptions} formOptions={formOptions} diffOptions={diffOptions} css={ css as string } js={ js as string } optionsOverride={ optionsOverride as string }>
            
            <PanelGroup direction="horizontal">
                <Panel style={formStyle} defaultSize={25}>
                    <Form  
                        onChange={(data: any) => {
                            console.log('update origin onChange');
                            setFormOptions(data);
                        }} 
                        onCss={(data: string) => {     
                            console.log('css', data);                       
                            setCss(data);
                            localStorage.setItem('css', data);
                        }}
                        onJs={(data: string) => {
                            setJs(data);
                            localStorage.setItem('js', data);
                        }}
                        onOptionsOverride={(data: string) => {
                            setOptionsOverride(data);
                            localStorage.setItem('optionsOverride', data);
                        }}
                    />
                </Panel>
                <PanelResizeHandle style={ borderStyle } />
                <Panel>
                    <PanelGroup direction="vertical">
                        <Panel>
                            <Player />
                        </Panel>
                        <PanelResizeHandle style={ borderStyle } />
                        <Panel>
                            <PanelGroup direction="horizontal">                                
                                <Panel>
                                    <Editor language={'javascript'} value={ getJs(diffOptions, optionsOverride as string) } readOnly={ true } onChange={() => {}} />
                                </Panel>
                            </PanelGroup>
                        </Panel>
                    </PanelGroup>
                </Panel>
            </PanelGroup>            
        </Provider>
    );

}

/*
for manager
<Panel>
    <Editor language={'css'} />
</Panel>
<PanelResizeHandle className="border-2" />
*/